import { createContext, useContext } from 'react';

import type { HighlightingMap } from '../types/internal.js';

export const TreeMapHighlightingMapContext = createContext<HighlightingMap>({});

export const useTreeMapHighlightingMap = () =>
  useContext(TreeMapHighlightingMapContext);

TreeMapHighlightingMapContext['displayName'] = 'TreeMapHighlightingMapContext';
